var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { StyledCard, FlexWrapper, StyledRouterLink } from "../styled";
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = function (path) {
            return location.pathname.includes(path);
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var isPerksEnabled = authentication.apps("perks");
        var isRewardAndRecognitionEnabled = authentication.apps("recognition") && !authentication.apps("recognition.recognition.rewardDisabled");
        var showWalletReportingTab = authentication.apps("wallet.users") || (authentication.apps("wallet.rewardWallet") && authentication.apps("wallet.tenantWallet"));
        return (React.createElement(Fragment, null,
            React.createElement(StyledCard, null,
                React.createElement(FlexWrapper, null,
                    isPerksEnabled && (React.createElement(StyledRouterLink, { to: "/reporting-v2/perks", isActive: this.isActive("/reporting-v2/perks") },
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.perks" }))),
                    React.createElement(StyledRouterLink, { to: "/reporting-v2/platform", isActive: this.isActive("/reporting-v2/platform") },
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.platform" })),
                    isRewardAndRecognitionEnabled && (React.createElement(StyledRouterLink, { to: "/reporting-v2/rewards", isActive: this.isActive("/reporting-v2/rewards") },
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.rewards" }))),
                    showWalletReportingTab && (React.createElement(StyledRouterLink, { to: "/reporting-v2/wallets", isActive: this.isActive("/reporting-v2/wallets") },
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.wallets" })))))));
    };
    return Tab;
}(Component));
export default Tab;
